import { Component, Input, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";

@Component({
  selector: "app-playing-card",
  templateUrl: "./playing-card.component.html",
  styleUrls: ["./playing-card.component.scss"],
})
export class PlayingCardComponent implements OnInit {
  readonly env: any = environment;
  @Input() value: string;
  @Input() name: string;
  @Input() selected: boolean = false;
  @Input() votingOpen: boolean = false;
  @Input() token: string;
  disabled: boolean = false;
  noName: boolean;

  constructor(public planningPokerService: PlanningPokerService) {}

  ngOnInit() {
    if (this.name) {
      if (this.name.length > 8) {
        this.name = this.name.substr(0, 7) + "...";
      }
      if (!this.value) {
        this.value = "-";
      }
      switch (this.value) {
        case "pause":
          this.disabled = true;
          break;
        case "-":
          this.disabled = true;
          break;
        case "?":
          this.disabled = true;
          break;
        default:
          this.disabled = false;
          break;
      }
    }

    if (!this.name) {
      this.noName = true;
    } else {
      this.noName = false;
    }
  }

  getClasses(classes) {
    if (classes === "disabled") {
      if (this.disabled) {
        return "st4-disabled";
      } else if (this.selected) {
        return "st4-filled";
      } else {
        return "st4";
      }
    }
    if (classes === "no-name") {
      if (this.noName) {
        return "no-name";
      }
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/playing-card/playing-card.component.ts